angular.module('directives.common')
    .directive('keyboardNav', keyboardNav);

//directive for inclusive keyboard events
function keyboardNav() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.on('keydown', function(event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    
                    element.triggerHandler('click');
                    
                    if (attrs.ngClick) {
                        scope.$apply(attrs.ngClick);
                    }
                }
            });
        }
    };
} 



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/common/keyboard-nav.js
 ** module id = 149
 ** module chunks = 1
 **/